import { render, staticRenderFns } from "./AndiamoPaiViewComponent.vue?vue&type=template&id=2408707a&scoped=true"
import script from "./AndiamoPaiViewComponent.vue?vue&type=script&lang=js"
export * from "./AndiamoPaiViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AndiamoPaiViewComponent.vue?vue&type=style&index=0&id=2408707a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408707a",
  null
  
)

export default component.exports